const routes = {
  root: '/service-record/details',
}

export default routes
